import { createClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL!;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);
export const supabaseEh = supabase.schema('eh'); 